module.exports = "/images/fi.svg";